// extracted by mini-css-extract-plugin
module.exports = {"level_0":"BoardTitle_level_0__ZCsJV","level_1":"BoardTitle_level_1__1EMRp","level_2":"BoardTitle_level_2__1tcY1"};